import * as React from "react";
import { Box } from "@chakra-ui/react";
import AnimatedProjectsSlideshow from "../molecules/AnimatedProjectsSlideshow";

const Projects = () => {
  return (
    <Box
      as="section"
      id="projects"
      className="scroll-section"
      h="100vh"
      w="full"
      display="flex"
      flexDirection="column"
      justifyContent="end"
      position="relative"
      overflow="hidden"
      scrollSnapAlign="start"
      minH="100vh"
      p={{ base: 0, md: 0 }}
      background={"linear-gradient( #F9F0DF, #F9F0DF )"}
    >
      <AnimatedProjectsSlideshow />
    </Box>
  );
};

export default Projects;
